function getRedirectUrl(): string {
  const { host, protocol } = window.location;
  const baseUrl = `${protocol}//${host}`;

  return baseUrl;
}

export default getRedirectUrl;
